










































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  INotificationTemplate,
  INotificationHook
} from "@/models/notifications";
import eventsMap from "@/components/app/global/timelineComponent/events";

@Component
export default class AutomationTableRow extends Vue {
  @Prop({ required: true })
  public template!: INotificationTemplate;

  @Prop({ default: null })
  public hookId!: INotificationHook["id"];

  @Prop({ default: false })
  public showCategory!: boolean;

  @Prop({ default: false })
  public canView!: boolean;

  @Prop({ default: false })
  public canDelete!: boolean;

  // Methods

  public mapHookName(hook) {
    return eventsMap?.[hook?.code]?.name || hook?.name;
  }
}
